import { FileAddOutlined } from '@ant-design/icons';
import { tran } from '@framework/engine/schema/translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '@framework/engine/schema/widgets/IWidgetType.ts';
import {
  WidgetCategory,
  WidgetMainType,
} from '@framework/engine/schema/widgets/Widget.ts';

import { createModuleTriggerFormSchema } from './createModuleTriggerFormSchema.ts';
import {
  type IModuleTriggerWidget,
  WidgetModuleTriggerType,
} from './IModuleTriggerWidget.ts';
import { ModuleTriggerConfigComponent as ModuleTriggerWidgetConfigComponent } from './ModuleTriggerConfigComponent.tsx';
import { ModuleTriggerConfigSchema } from './ModuleTriggerConfigSchema.ts';
import { ModuleTriggerPreviewComponent } from './ModuleTriggerPreviewComponent.tsx';
import { ModuleTriggerWidgetComponent } from './ModuleTriggerWidgetComponent.tsx';

// L'augmentation di `WidgetType.ModuleTrigger` è dichiarata in
// `IModuleTriggerWidget.ts`, accanto all'interfaccia che la usa.
export const TriggerModuleMetaKey = 'triggeredModule' as const;

/**
 * Widget di tipo "Attiva modulo".
 */
export const ModuleTriggerWidgetType: IWidgetType<IModuleTriggerWidget> = {
  type: WidgetModuleTriggerType,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Attivazione moduli',
  icon: <FileAddOutlined />,
  formComponent: ModuleTriggerWidgetComponent,
  createFormSchema: createModuleTriggerFormSchema,
  previewComponent: ModuleTriggerPreviewComponent,
  configValidator: ModuleTriggerConfigSchema,
  configComponent: ModuleTriggerWidgetConfigComponent,
  configOptions: {
    hideDirectives: true,
  },
  hideFlags: true,
  translationSchema: tran.widget({}),
  rules: [],
  hasValue: false,
};
